export enum ResourcesScopes {
  CAN_VIEW = 'can_view_resources',
  CAN_ASSIGN_MODULE_TO_CLASSROOM = 'can_assign_module_to_classroom',
}
